import * as fromAppointments from "./appointmentsSlice";
import * as fromAuth from "./authSlice";
import * as fromUserSettings from "./userSettingsSlice";
import * as fromSchedule from "./scheduleSlice";
import * as fromHostAgency from "./hostAgencySlice";
import * as fromVideoCall from "./videoCallSlice";

// Appointments
export const isAppointmentLoading = (state) =>
  fromAppointments.isAppointmentLoading(state.appointments);
export const getAppointment = (state) =>
  fromAppointments.getAppointment(state.appointments);
export const getAppointmentError = (state) =>
  fromAppointments.getAppointmentError(state.appointments);

// Authentication
export const isLoggingIn = (state) => fromAuth.isLoggingIn(state.auth);
export const getCurrentUser = (state) => fromAuth.getCurrentUser(state.auth);
export const getCurrentUserRole = (state) =>
  fromAuth.getCurrentUserRole(state.auth);
export const getAuthError = (state) => fromAuth.getError(state.auth);
export const isAuthenticated = (state) => fromAuth.isAuthenticated(state.auth);
export const isAuthorized = (role) => (state) =>
  fromAuth.isAuthorized(state.auth, role);
export const getSessionExpirationTime = (state) =>
  fromAuth.getSessionExpirationTime(state.auth);

// User Settings
export const isUserSettingsLoading = (state) =>
  fromUserSettings.isUserSettingsLoading(state.userSettings);
export const getUserSettings = (state) =>
  fromUserSettings.getUserSettings(state.userSettings);
export const getUserSettingsError = (state) =>
  fromUserSettings.getUserSettingsError(state.userSettings);
export const getUserProfileImage = (state) =>
  fromUserSettings.getUserProfileImage(state.userSettings);
export const getUserLogo = (state) =>
  fromUserSettings.getUserLogo(state.userSettings);
export const getTimeOffset = (state) =>
  fromUserSettings.getTimeOffset(state.userSettings);
export const getDurationAppSetting = (state) =>
  fromUserSettings.getDurationIncrement(state.userSettings);

// Schedule
export const isScheduleLoading = (state) =>
  fromSchedule.isScheduleLoading(state.schedule);
export const getSchedule = (state) => fromSchedule.getSchedule(state.schedule);
export const getEvents = (state) => fromSchedule.getEvents(state.schedule);
export const getScheduleError = (state) =>
  fromSchedule.getScheduleError(state.schedule);

// Host Agency
export const isHostAgencyLoading = (state) =>
  fromHostAgency.isLoading(state.hostAgency);
export const getHostAgency = (state) =>
  fromHostAgency.getHostAgency(state.hostAgency);
export const isHostNotFound = (state) =>
  fromHostAgency.isHostNotFound(state.hostAgency);
export const getHostAgencyError = (state) =>
  fromHostAgency.getError(state.hostAgency);

// Video Call
export const isVideoCallLoading = (state) =>
  fromVideoCall.isLoading(state.videoCall);
export const getVideoCallError = (state) =>
  fromVideoCall.getError(state.videoCall);
export const getVideoCallToken = (state) =>
  fromVideoCall.getToken(state.videoCall);
export const getVideoCallRoom = (state) =>
  fromVideoCall.getRoom(state.videoCall);
export const getVideoCallAppointment = (state) =>
  fromVideoCall.getAppointment(state.videoCall);
export const getVideoCallExitedParticipant = (state) =>
  fromVideoCall.getExitedParticipant(state.videoCall);
export const isVideoCallReady = (state) =>
  fromVideoCall.isCallReady(state.videoCall);
export const isVideoCallEnded = (state) =>
  fromVideoCall.isCallEnded(state.videoCall);
export const isMeetingEnded = (state) =>
  fromVideoCall.isMeetingEnded(state.videoCall);
export const getVideoCallRemoteParticipants = (state) =>
  fromVideoCall.getRemoteParticipants(state.videoCall);
export const getVideoCallStatus = (state) =>
  fromVideoCall.getCurrentStatus(state.videoCall);
export const videoCallAllowedActioins = (state) =>
  fromVideoCall.allowedActions(state.videoCall);
export const getActivityId = (state) =>
  fromVideoCall.getActivityId(state.videoCall);
